import type Document from '../entities/document';
import {isDemo} from '../lib/demo';

export const MAX_LOCAL = isDemo() ? Number.MAX_SAFE_INTEGER : 5_120;

// WebKit queues may hold bytes in place of a File until IndexedDB restores it.
export type QueuedFileBytes = {
    queuedFileBytes: true;
    bytes: ArrayBuffer;
    name: string;
    type: string;
    lastModified: number;
};

export function isQueuedFileBytes(value: unknown): value is QueuedFileBytes {
    return typeof value === 'object' && value !== null &&
        (value as QueuedFileBytes).queuedFileBytes === true &&
        (value as QueuedFileBytes).bytes instanceof ArrayBuffer;
}

export function isRenameOnlyUpload(doc: Document): boolean {
    const content = doc.buffer || doc.plainText || '';
    return !!(doc.dbAddedOn && doc.nameChange &&
        !(doc.fileHandle instanceof Blob) && !isQueuedFileBytes(doc.fileHandle) &&
        (doc.uri || !doc.local || content.length > MAX_LOCAL));
}
